"use client";

import {
  ahmadNasser,
  alhusseinAlakraa,
  aliZaher,
  farahMalla,
  haninKenany,
  mohammedAssi,
  omarRasheed,
  osamaIbrahim,
  wardKhaddour,
  yousefOmran,
} from "@/assets/imgs";

import MemberCard from "./MemberCard";
import { useTranslations } from "next-intl";
import { Slider } from "./Slider";

const teamMembers = [
  {
    name: "Ahmad Nasser",
    role: "Founder & CEO",
    img: ahmadNasser,
  },
  {
    name: "Ward Khaddour",
    role: "Front End Developer",
    img: wardKhaddour,
  },
  {
    name: "Mohammed Assi",
    role: "Back End Developer",
    img: mohammedAssi,
  },
  {
    name: "Alhussein Alakraa",
    role: "Flutter Developer",
    img: alhusseinAlakraa,
  },
  {
    name: "Ali Zaher",
    role: "Front End Developer",
    img: aliZaher,
  },

  {
    name: "Omar Rasheed",
    role: "Social Media Specialist",
    img: omarRasheed,
  },

  {
    name: "Osama Ibrahim",
    role: "Graphic Designer",
    img: osamaIbrahim,
  },
  {
    name: "Hanin Kenany",
    role: "Back End Developer",
    img: haninKenany,
  },
  {
    name: "Yousef Omran",
    role: "Flutter Developer",
    img: yousefOmran,
  },
    {
    name: "Farah Malla",
    role: "Front End Developer",
    img: farahMalla,
  },
];

type Props = {
  className: string;
};
const TeamMembers = ({ className }: Props) => {
  const t = useTranslations();
  return (
    <>
      <div className={`${className}`}>
        <div className="flex flex-col items-center gap-10  text-white">
          <p className="ْtext-md uppercase rtl:text-base rtl:font-semibold">
            {t("aboutPage.team")}
          </p>
          <h3 className="text-center text-3xl font-bold">
            {t("aboutPage.meetTeam")}
          </h3>
        </div>

        <Slider
        autoPlay
        delay={1500}
          slides={teamMembers.map((member) => (
            <div key={member.name} className="pb-32 pt-20">
              <MemberCard
                img={member.img}
                role={member.role}
                name={member.name}
              />
            </div>
          ))}
            breakpoints={{
          1028:3,
          768: 2,
          375: 1,
        }}
        />
      </div>
    </>
  );
};

export default TeamMembers;
